import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Input
name: Input
category: React - Bulma
---

An `Input` component based on Bulma `.input`. This is a wrapper for input fields.

If you're trying to build a form, take a look at the different `Field` components.
Using those will help ensure consistency.

See [Bulma Documentation](http://bulma.io/documentation/form/input/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <form>
    <Field>
      <Label htmlFor="example">Input name</Label>
      <Control>
        <Input name="example" type="text" onChange={onChangeHandler} />
      </Control>
    </Field>
  </form>
```
*/

/**
* @TODO Automatically set accessibility attributes.
* @TODO Add support for input states.
* @TODO Add support for icons.
*/
function Input(props) {
  const {
    name, className, inputSize, onChange, ...rest
  } = props

  const classes = [
    'input',
    inputSize ? `is-${inputSize}` : '',
    className || '',
  ]

  const onChangeHandler = (e) => {
    if (typeof onChange === 'function') {
      onChange(name, e.target.value)
    }
  }

  return (
    <input
      id={name}
      {...rest}
      name={name}
      onChange={onChangeHandler}
      className={classes.join(' ')}
    />
  )
}

Input.defaultProps = {
  type: 'text',
}

Input.propTypes = {
  // Input type.
  type: PropTypes.string,
  // Name/id of input.
  name: PropTypes.string.isRequired,
  // Size of input: "small", "medium", "large"
  inputSize: PropTypes.string,
}

export default Input
